import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Typography } from '@mui/material';

const CompanyCaroselSection = () => {
    return (
        <Container sx={{marginBottom: 10}}>
            <Box
                sx={{
                    height: '26px',
                    backgroundColor: '#ffffff',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                    //borderBottom: '1px solid #ddd',
                }}>
                    <Typography 
                                        variant="h4" 
                                        sx={{ 
                                            fontSize: 36, 
                                            fontWeight: 600, // semi-bold
                                            color: '#111111', 
                                            marginBottom: 1,
                                            textAlign: 'center'
                                        }}
                                    >
                                        Working With
                                    </Typography>
            </Box>
            <Box 
                sx={{
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 4,
                    p: 4,
                    marginBottom: 10
                    //borderBottom: '1px solid #ddd',
                }}>
                    <img src="./nordic_logo.png" alt="nordiclogo" />
                    <img src="./rak_logo.png" alt="raklogo" />
                    <img src="./aws_logo.png" alt="awslogo" />
                    <img src="./lora_logo.png" alt="loralogo" />
                    <img src="./ble_logo.png" alt="blelogo" />
                    <img src="./mqtt_logo.png" alt="mqttlogo" />
                    <img src="./wifi_logo.png" alt="wifilogo" />
            </Box>
        </Container>
    );
};

export default CompanyCaroselSection;